import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import * as L from 'leaflet';

@Component({
  selector: 'app-modal-map',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule
  ],
  templateUrl: './modal-map.component.html',
  styleUrl: './modal-map.component.scss'
})
export class ModalMapComponent {
  map: L.Map;
  marker = null
  icon = ''

  constructor(
    public dialogRef: MatDialogRef<ModalMapComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.initMap()
  }

  private initMap(): void {
    if(Array.isArray(this.data.geolocationPoint) && this.data.geolocationPoint.length > 0){
      this.map = L.map('mapDetail', {
        center: [parseFloat(this.data.geolocationPoint[0]), parseFloat(this.data.geolocationPoint[1])],
        zoom: 15
      });
    }else{
      this.map = L.map('mapDetail').fitWorld();
    }

    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 20,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    });

    tiles.addTo(this.map);

    let color_route = '#27499e'
    var routeIcon = L.divIcon({
      html: `<span class="svg-icon svg-icon-danger svg-icon-3x">
        <svg fill=${color_route} viewBox="0 0 297 297" style="enable-background:new 0 0 297 297;" xml:space="preserve">
        <path d="M148.5,0C87.43,0,37.747,49.703,37.747,110.797c0,91.026,99.729,179.905,103.976,183.645
        c1.936,1.705,4.356,2.559,6.777,2.559c2.421,0,4.841-0.853,6.778-2.559c4.245-3.739,103.975-92.618,103.975-183.645
        C259.253,49.703,209.57,0,148.5,0z M148.5,79.693c16.964,0,30.765,13.953,30.765,31.104c0,17.151-13.801,31.104-30.765,31.104
        c-16.964,0-30.765-13.953-30.765-31.104C117.735,93.646,131.536,79.693,148.5,79.693z"/>`,
      iconSize: [30, 30],
      iconAnchor: [15, 20],
      className: 'leaflet-marker'
    });

    if(Array.isArray(this.data.geolocationPoint) && this.data.geolocationPoint.length > 0){
      this.marker = L.marker([parseFloat(this.data.geolocationPoint[0]), parseFloat(this.data.geolocationPoint[1])], { icon: routeIcon }).addTo(this.map)
    }
  }

  onClose() {
    this.dialogRef.close('Close')
  }
}
